import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect } from "@wordpress/element";
import { __, sprintf } from "@wordpress/i18n";
import { UserPageNotificationsContext } from "../../../providers/UserPageNotificationsContextProvider";
import { PageContentWrap, PageWrap } from "../Page/Page";
import { NotificationItem } from "./components/NotificationItem";
function NotificationsPage() {
    const { state: { newComments, loading }, checkNewComments, } = useContext(UserPageNotificationsContext);
    useEffect(() => {
        checkNewComments();
    }, []);
    const groupedComments = newComments.reduce((acc, comment) => {
        const key = `${comment.type_id}-${comment.type}`;
        if (!acc[key]) {
            acc[key] = {
                typeId: comment.type_id,
                type: comment.type,
                numberOfComments: 0,
                subjectName: comment.subject_name || "",
                subjectHash: comment.subject_hash || "",
            };
        }
        acc[key].numberOfComments += 1;
        return acc;
    }, {});
    return (_jsx(PageWrap, { loading: loading, onRefresh: checkNewComments, children: _jsxs(PageContentWrap, { children: [_jsx("p", { className: "wpqt-text-center", children: sprintf(__("You have %d new %s", "quicktasker"), newComments.length, newComments.length === 1
                        ? __("comment", "quicktasker")
                        : __("comments", "quicktasker")) }), _jsx("div", { className: "wpqt-grid wpqt-grid-cols-1  sm:wpqt-grid-cols-2 wpqt-gap-2 lg:wpqt-grid-cols-4", children: Object.values(groupedComments).map((notification) => (_jsx(NotificationItem, { notification: notification }, notification.typeId))) })] }) }));
}
export { NotificationsPage };
